(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/hooks/assets/javascripts/use-static-tabs.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/hooks/assets/javascripts/use-static-tabs.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isMobile = svs.core.detect.formfactor.mobile();
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const useStaticTabs = () => {
  const staticTabs = svs.racing_game.data.editorialTabs.map(tab => {
    switch (tab.tabType) {
      case 'spelguiden':
        return {
          component: () => svs.racing_game.components.gameGuide.GameGuide,
          componentName: 'react:game-guide',
          componentProps: _objectSpread({}, svs.racing_game.data.gameGuideProps),
          label: tab.label,
          param: 'spelguide'
        };
      case 'mina-spel':
        {
          if (!isSelfService) {
            return {
              component: () => svs.racing_game.components.myGaming.MyGamingOverview,
              componentName: 'react:my-gaming',
              componentProps: {},
              label: tab.label,
              param: 'mina-spel'
            };
          }
          return null;
        }
      case 'spelanalys-high-five':
        return {
          component: () => svs.racing_game.components.gameAnalyze.GameAnalyzeReactWrapper,
          componentName: 'react:game-analyze',
          componentProps: {},
          label: tab.label,
          param: 'spelanlys-high-five'
        };
      default:
        return _objectSpread(_objectSpread({}, tab), {}, {
          component: () => svs.racing_game.WidgetArea,
          componentProps: {
            area: tab.area
          },
          param: tab.serverName,
          pushState: false
        });
    }
  }).filter(tab => tab !== null);
  if (isMobile) {
    staticTabs.unshift({
      fixedItem: 'sport',
      label: 'Lopp',
      param: 'spela',
      selected: true
    });
  }
  return staticTabs;
};
svs.racing_game.components.hooks.useStaticTabs = useStaticTabs;

 })(window);